import { __rest } from "tslib";
import React from 'react';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color } from '@scp/ui-shared/theme/variables';
import { IconButton } from '@scp/ui-shared/components/buttons';
var TEXT = {
  ACCESSIBILITY_LABEL: function ACCESSIBILITY_LABEL(title) {
    var selectedValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return "".concat(title).concat(selectedValue ? " , Current Value: ".concat(selectedValue) : '');
  }
};
export function TriggerButton(_a) {
  var title = _a.title,
      _a$selectedValue = _a.selectedValue,
      selectedValue = _a$selectedValue === void 0 ? '' : _a$selectedValue,
      _a$iconName = _a.iconName,
      iconName = _a$iconName === void 0 ? 'arrow-drop-down' : _a$iconName,
      otherProps = __rest(_a, ["title", "selectedValue", "iconName"]);

  return React.createElement(IconButton, Object.assign({
    "aria-label": TEXT.ACCESSIBILITY_LABEL(title, selectedValue),
    title: title,
    type: "button"
  }, otherProps), React.createElement(Icon, {
    name: iconName,
    color: color.icon,
    size: 26
  }));
}